import { render } from "./QianWenBotSettings.vue?vue&type=template&id=2cea805c"
import script from "./QianWenBotSettings.vue?vue&type=script&lang=js"
export * from "./QianWenBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__